import ApplicationRecord from './ApplicationRecord';
import ImageRecord from './ImageRecord';
/**
 * Contact page.
 *
 *
 */
export default class ContactPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * Absolute path.
     * @type {String}
     */
    URL: '',
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {String}
     */
    Content: '',
    /**
     * Relative path to go the
     * page.
     * Use a <Link> to works without re-loading
     * @type {String}
     */
    NewOfferPage: '/new-offer/',
    /**
     * Relative path to go the
     * page.
     * Use a <Link> to works without re-loading
     * @type {String}
     */
    ContactPage: '/contact-us/',
    /**
     * @type {Object}
     */
    _embedded: {},
  }) {
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroCaption() {
    return '' + this._getOne('HeroText', String);
  }

  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroImage() {
    return this._getOne('HeroImg', ImageRecord).set('alt', this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne('HeroMobileImg', ImageRecord).set(
      'alt',
      this.HeroCaption
    );
  }

  /**
   * @return {ImageRecord} Thumb for contact card
   */
  contactImage() {
    return this._getOne('ContactImg', ImageRecord).set('alt', this.Title);
  }
}



// WEBPACK FOOTER //
// ./src/models/ContactPage.js